module.exports = __webpack_public_path__ + "static/media/barn.09603ff5.webp";